module.exports = __webpack_public_path__ + "img/数字孪生仓储物流管理平台.88c63afd.png";